import { render, staticRenderFns } from "./nps.vue?vue&type=template&id=edf52212"
import script from "./nps.vue?vue&type=script&lang=js"
export * from "./nps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports